import type { ReactNode } from 'react';
import { cn } from '../../../components/ui/utils';

export type HrTone = 'success' | 'warning' | 'danger' | 'serious' | 'link' | 'muted';

const TONE_CLASSES: Record<HrTone, string> = {
  success: 'border-success-border bg-success-bg text-success',
  warning: 'border-warning-border bg-warning-bg text-warning',
  danger: 'border-destructive-border bg-destructive-bg text-destructive',
  serious: 'border-destructive-border bg-destructive-bg text-destructive',
  link: 'border-link bg-selection text-link',
  muted: 'border-border bg-muted text-muted-foreground',
};

export function HrStatusPill({
  children,
  tone = 'muted',
  className,
}: {
  children: ReactNode;
  tone?: HrTone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium',
        TONE_CLASSES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
